// add user-agent to html element as data attribute
// (function() {
// 	var doc = document.documentElement;
// 	doc.setAttribute('data-useragent', navigator.userAgent);
// }());

// lazysizes before document ready
(function() {
	window.lazySizesConfig = window.lazySizesConfig || {};
	window.lazySizesConfig.customMedia = {
		'--small': '(max-width: 767px)',
		'--medium': '(max-width: 1067px)'
	};
}());

//reCaptcha callback
var onRecaptchaSubmit = function (token) {
    
    jQuery('.jsSaleForceFormSubmit').prop("disabled", false);

    jQuery.ajax({
        method: 'POST',
        data: { tokenstring: token },
        url: '/api/services/recaptchavalidate',
        success: function (data, status, xhr) {
            if (data == "Pass") {
                jQuery('.jsSaleForceFormSubmit').prop("disabled", false);
            }
        },
        error: function (response) {
            jQuery('.jsSaleForceFormSubmit').prop("disabled", true);
            //this need to be called if submit click again
            grecaptcha.reset();
            
            console.log("recaptcha error");
        }
    });    
};


// document ready
jQuery(document).ready(function($) {

    // ---------------------------------------------------------------------
    // | salesForce form                                                   |
    // ---------------------------------------------------------------------


    (function () {
 
        //specific for Salesforce forms
        if ($('.jsSaleForceForm').length) {

            var jsSaleForceFormSubmitFunction = function () {
                var countryType = "au";  //default
                if (jQuery('.jsSaleForceForm').length) {
                    countryType = jQuery('.jsSaleForceForm').data("country");
                }

                var allPass = true;

                //reset all validation error
                jQuery('.jsAddressCityValidationError').removeClass("field-validation-error");
                jQuery('.jsEmailValidationError').removeClass("field-validation-error");
                jQuery('.jsPhoneValidationError').removeClass("field-validation-error");
                jQuery('.jsAddressCityValidationError').hide();
                jQuery('.jsEmailValidationError').hide();
                jQuery('.jsPhoneValidationError').hide();
                jQuery('.jsFieldError').remove();
                if (jQuery('.jsValidationResult').length) {
                    jQuery('.jsValidationResult').hide();
                }
                jQuery('.jsSaleForceFormSubmit').prop("disabled", true);

                //required field validate first
                jQuery('.jsRequired').each(function (index) {
                    if (!jQuery(this).val()) {
                        jQuery(this).parent().append("<label id='" + jQuery(this).attr('id') + "-error' class='field-validation-error jsFieldError' for='" + jQuery(this).attr('id') + "'>This field is required</label>");
                        allPass = false;
                        jQuery('.jsSaleForceFormSubmit').prop("disabled", false);
                    }
                    else if (jQuery(this).is(':checkbox') && !jQuery(this).is(':checked')) {
                        jQuery(this).parent().parent().parent().parent().append("<label id='" + jQuery(this).attr('id') + "-error' class='field-validation-error jsFieldError' for='" + jQuery(this).attr('id') + "'>This field is required</label>");
                        allPass = false;
                        jQuery('.jsSaleForceFormSubmit').prop("disabled", false);
                    }
                });

                //check if lat and long is populated manually not autofill
                if (jQuery('.jsLatitude').length && !jQuery('.jsLatitude').val()) {
                    window.alert("Please enter a valid suburb or postcode and select from the list");
                    allPass = false;
                    jQuery('.jsSaleForceFormSubmit').prop("disabled", false);
                }

                if (allPass) {
                    jQuery.when(validateEmail(), validatePhone(), validateAddress()).done(function (a1, a2) {


                        if (allPass) {
                            jQuery('.jsSaleForceForm').submit();
                        }
                        else {
                            if (jQuery('.jsValidationResult').length) {
                                jQuery('.jsValidationResult').show();
                                jQuery('.jsValidationResult').html('Please correct the invalid data');
                            }
                        }

                        jQuery('.jsSaleForceFormSubmit').prop("disabled", false);
                    });
                }

                function validateAddress() {
                    //disabled for now since using google map
                    //if (jQuery('.jsAddressCityValidate').length > 0 && jQuery('.jsAddressStateValidate').length > 0 && jQuery('.jsAddressCityValidate').val() != "" && jQuery('.jsAddressStateValidate').val() != "") {
                    //    return jQuery.ajax({
                    //        method: 'POST',
                    //        data: { address: jQuery('.jsAddressCityValidate').val() + ' ' + jQuery('.jsAddressStateValidate').val(), country: countryType },
                    //        url: '/api/ExperianValidate/ValidateAddress',
                    //        success: function (data, status, xhr) {
                    //            //console.log(data);
                    //            if (data == "Pass") {
                    //                allPass = true;
                    //            }
                    //            else {
                    //                allPass = false;
                    //                jQuery('.jsAddressCityValidationError').addClass("field-validation-error");
                    //                jQuery('.jsAddressCityValidationError').show();
                    //            }
                    //        },
                    //        error: function (response) {
                    //            allPass = false;
                    //        }
                    //    });
                    //}
                    //else {
                    //    allPass = true;
                    //}


                }

                function validateEmail() {
                    if (jQuery('.jsEmailValidate').length > 0 && jQuery('.jsEmailValidate').val() != "") {
                        return jQuery.ajax({
                            method: 'POST',
                            data: { email: jQuery('.jsEmailValidate').val() },
                            url: '/api/ExperianValidate/ValidateEmail',
                            success: function (data, status, xhr) {
                                if (data == "Pass") {
                                    //do nothing
                                }
                                else {
                                    allPass = false;
                                    jQuery('.jsEmailValidationError').addClass("field-validation-error");
                                    jQuery('.jsEmailValidationError').show();
                                }
                            },
                            error: function (response) {
                                allPass = false;
                            }
                        });
                    }
                    else {
                        //do nothing
                    }
                }

                function validatePhone() {
                    if (jQuery('.jsPhoneValidate').length > 0 && jQuery('.jsPhoneValidate').val() != "") {
                        return jQuery.ajax({
                            method: 'POST',
                            data: { phoneNumber: jQuery('.jsPhoneValidate').val(), country: countryType },
                            url: '/api/ExperianValidate/ValidatePhone',
                            success: function (data, status, xhr) {
                                if (data == "Pass") {
                                    //do nothing
                                }
                                else {
                                    allPass = false;
                                    jQuery('.jsPhoneValidationError').addClass("field-validation-error");
                                    jQuery('.jsPhoneValidationError').show();
                                }
                            },
                            error: function (response) {
                                allPass = false;
                            }
                        });
                    }
                    else {
                        //do nothing
                    }
                }
            }

            var countryType = $('.jsSaleForceForm').data("country");
            var addressType = $('.jsSaleForceForm').data("addresstype");

            if ($('.jsAddressGoogleAuto').length) {

                var el = document.querySelector(".jsAddressGoogleAuto");

                if (addressType == 'region')
                {
                    var _autocompleteSalesforce = new google.maps.places.Autocomplete(
                        el, {
                            types: ['(regions)'],
                            componentRestrictions: { country: countryType }
                        });
                }
                else
                {
                    var _autocompleteSalesforce = new google.maps.places.Autocomplete(
                        el, {
                            types: ['address'],
                            componentRestrictions: { country: countryType }
                        });
                }

                google.maps.event.addListener(_autocompleteSalesforce, 'place_changed', function () {
                    var $result = _autocompleteSalesforce.getPlace();

                    if (!$result.geometry || !$result.geometry.location) {
                        // User pressed the Enter key, or the Place Details request failed.
                        window.alert("Please enter a valid suburb or postcode and select from the list");
                        return;
                    }
                    
                    if ($('.jsLatitude').length)
                    {                        
                        $('.jsLatitude').val($result.geometry.location.lat());
                    }
                    if ($('.jsLongitude').length) {
                        $('.jsLongitude').val($result.geometry.location.lng());
                    }

                    var $formAddress = '';

                    for (var i = 0; i < $result.address_components.length; i++) {
                        for (var j = 0; j < $result.address_components[i].types.length; j++) {

                            // building up adddress
                            if ($result.address_components[i].types[j] == 'subpremise') {
                                $formAddress = $result.address_components[i].long_name + '/';
                            }
                            if ($result.address_components[i].types[j] == 'street_number') {
                                $formAddress = $formAddress + $result.address_components[i].long_name;
                            }
                            if ($result.address_components[i].types[j] == 'route') {
                                $formAddress = $formAddress + ' ' + $result.address_components[i].long_name;
                            }

                            if ($formAddress != '')
                            {
                                $('.jsAddressStreet').val($formAddress);
                            }

                            // country
                            if ($result.address_components[i].types[j] == 'country') {

                                if ($('.jsAddressCountryValidate').length) {
                                    $('.jsAddressCountryValidate').val($result.address_components[i].long_name);
                                }
                                
                                if ($('.jsAddressCountryDropListValidate').length)
                                {
                                    $('.jsAddressCountryDropListValidate')
                                                .val($result.address_components[i].short_name)
                                                .trigger('change');
                                }
                                
                            }
                            // state
                            if ($result.address_components[i].types[j] == 'administrative_area_level_1') {

                                //reset since some NZ addresses might not have state
                                $('.jsAddressStateValidate').val('');

                                if ($('.jsAddressStateValidate').length) {
                                    $('.jsAddressStateValidate').val($result.address_components[i].short_name);
                                }

                                if($('.jsAddressStateDropListValidate').length)
                                {
                                    $('.jsAddressStateDropListValidate')
                                                .val($result.address_components[i].short_name)
                                                .trigger('change');
                                }
                            }
                           

                            // suburb				            
                            if (countryType == 'au' && $result.address_components[i].types[j] == 'locality') {
                                    if ($('.jsAddressCityValidate').length) {
                                        $('.jsAddressCityValidate').val($result.address_components[i].long_name);
                                    }
                                
                            } else {
                                if ($result.address_components[i].types[j] == 'sublocality_level_1') {
                                    if ($('.jsAddressCityValidate').length) {
                                        $('.jsAddressCityValidate').val($result.address_components[i].long_name);
                                    }
                                }
                            }

                            
                            // postcode
                            if ($result.address_components[i].types[j] == 'postal_code') {
                                if ($('.jsAddressPostCodeValidate').length) {
                                    $('.jsAddressPostCodeValidate').val($result.address_components[i].long_name);
                                }                                
                            }
                        }
                    }
                });
            }

            $('.jsSaleForceFormSubmit').on('click', function (e) {
                jsSaleForceFormSubmitFunction();
            });

        }
        

    }());

	// ---------------------------------------------------------------------
	// | sitewide                                                          |
	// ---------------------------------------------------------------------

	// user agent detection
	(function() {
		// apple devices
		if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
			$('body').addClass('iosDevice');
		}
		// ie
		if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
			$('body').addClass('ie');
		}
		// safari
		if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') == -1) {
			$('body').addClass('safari');
		}
		// edge
		if (/Edge\/\d./i.test(navigator.userAgent)) {
			$('body').addClass('ieEdge');
		}
	}());

	// cookie disclaimer
	(function () {
		if ($('.jsCookieDisclaimer').length > 0) {
			if (localStorage.getItem('cookieDisclaimer') == null) {
				$('.jsCookieDisclaimer').fadeIn();
			}
			localStorage.setItem('cookieDisclaimer', 'seen');
			$('.jsBtnCookieDisclaimer').on('click', function (e) {
				e.preventDefault();
				if (window.localStorage) {
					localStorage.setItem('cookieDisclaimer', 'seen');
					$('.jsCookieDisclaimer').fadeOut();
				} else {
					$('.jsCookieDisclaimer').fadeOut();
				}
			});
		}
	}());

	// header nav
	(function() {
		// touch nav
		enquire.register('screen and (max-width: 1151px)', {
			// hamburger
			setup: function() {
				$('#pageNav .hamburger').on('click', function(e) {
					e.preventDefault();
					if (!$(this).hasClass('is-active')) {
						closeActive();
					}
					if ($(this).hasClass('is-active')) {
						closeAll();
					} else {
						$(this).addClass('is-active');
						$('html').addClass('nav-open');
						$('#pageNav .nav, #pageNav .navMobileQuicklinks').addClass('active');
						$('#pageOverlay').addClass('active');
					}
				});
			},
			// subnav
			match: function() {
				closeAll();
				$('#pageNav .toggle').unbind('click');
				$('#pageNav .toggle').on('click', function(e) {
					var $dropdown = $(this).siblings('.dropdown');
					e.preventDefault();
					$('#pageNav .dropdown:visible').not($dropdown).removeClass('active').slideToggle(200);
					$('#pageNav .toggle.active').not(e.target).removeClass('active');
					$(this).toggleClass('active');
					$dropdown.slideToggle(200).toggleClass('active');
				});
			}
		});
		// desktop main nav
		enquire.register('screen and (min-width: 1152px)', {
			match: function() {
				closeAll();
				$('#pageNav .toggle').unbind('click');
				$('#pageNav .toggle').on('click', function(e) {
					var $this = $(this).parent();
					var $dropdown = $(this).siblings('.dropdown');
					e.preventDefault();
					if (!$this.hasClass('active')) {
						closeActive();
					}
					if ($this.hasClass('active')) {
						closeAll();
					} else {
						$dropdown.stop(true).slideToggle(200);
						$this.addClass('active');
						$('#pageOverlay').addClass('active');
					}
				});
			}
		});
		// utility nav
		$('#pageNav .btnUtility:not(#pageNav .y-shop > a)').on('click', function(e) {
			var $this = $(this).parent('li');
			if ($this.hasClass('active')) {
				closeAll();
			} else {
				closeActive();
				$this.addClass('active');
				$('html').addClass('utility-open');
				$('#pageOverlay').addClass('active');
			}
			e.preventDefault();
		});
		// close all on overlay or header click
		$('#pageOverlay').on('click', function() {
			closeAll();
		});
		$('#pageHeader').on('click', function(e) {
			if ($(e.target).is(this) || $(e.target).is('#pageHeader > .container')) {
				closeAll();
			}
		});
		// close active items
		function closeActive() {
			$('#pageNav').find('.active').removeClass('active');
			$('#pageNav').find('.is-active').removeClass('is-active');
			$('#pageNav .dropdown:visible').slideUp(100);
		}
		// close all
		function closeAll() {
			$('#pageNav').find('.active').removeClass('active');
			$('#pageNav').find('.is-active').removeClass('is-active');
			$('#pageNav .dropdown:visible').slideUp(100);
			$('#pageOverlay').removeClass('active');
			$('html').removeClass('nav-open utility-open');
		}
	}());

	// header nav yshop only
	(function() {
		// touch nav
		enquire.register('screen and (max-width: 1151px)', {
			// hamburger
			setup: function() {
				$('.y-pageNav .hamburger').on('click', function(e) {
					e.preventDefault();
					if (!$(this).hasClass('is-active')) {
						closeActive();
					}
					if ($(this).hasClass('is-active')) {
						closeAll();
					} else {
						$(this).addClass('is-active');
						$('html').addClass('nav-open');
						$('.y-pageNav .nav, .y-pageNav .navMobileQuicklinks').addClass('active');
						$('#pageOverlay').addClass('active');
					}
				});
			},
			// subnav
			match: function() {
				closeAll();
				$('.y-pageNav .toggle').unbind('click');
				$('.y-pageNav .toggle').on('click', function(e) {
					var $dropdown = $(this).siblings('.dropdown');
					if(!$(this).hasClass('active')) {
						e.preventDefault();
						$('.y-pageNav .dropdown:visible').not($dropdown).removeClass('active').slideToggle(200);
						$('.y-pageNav .toggle.active').not(e.target).removeClass('active');
						$(this).toggleClass('active');
						$dropdown.slideToggle(200).toggleClass('active');
					}
					
				});
			}
		});
		// desktop main nav
		enquire.register('screen and (min-width: 1152px)', {
		    match: function () {
		        $('.y-pageNav .toggle').unbind('mouseenter');
		        $('.y-pageNav .toggle').on('click', function (e) {
		            var $this = $(this).parent();
		            var $dropdown = $(this).siblings('.dropdown');
		            e.preventDefault();
		           
		            closeActive();
		            setTimeout(function () {
		                $dropdown.slideToggle(300).toggleClass('active');		                    
		                $('#pageOverlay').addClass('active');
		            }, 350);
		           

		            $dropdown.on('mouseleave', function (e) {
		                closeAll();
		            })
		        });
		        
		        
		    }
		});
		// utility nav
		$('.y-pageNav .btnUtility:not(.y-pageNav .y-shop > a)').on('click', function(e) {
			var $this = $(this).parent('li');
			if ($this.hasClass('active')) {
				closeAll();
			} else {
				closeActive();
				$this.addClass('active');
				$('html').addClass('utility-open');
				$('#pageOverlay').addClass('active');
			}
			e.preventDefault();
		});
		// close all on overlay or header click
		$('#pageOverlay').on('click', function() {
			closeAll();
		});
		$('#pageHeader').on('click, mouseenter', function(e) {
			if ($(e.target).is(this) || $(e.target).is('#pageHeader > .container')) {
				closeAll();
			}
		});
		// close active items
		function closeActive() {
			$('.y-pageNav').find('.active').removeClass('active');
			$('.y-pageNav').find('.is-active').removeClass('is-active');
			$('.y-pageNav .dropdown:visible').hide();
		}
		// close all
		function closeAll() {
			$('.y-pageNav').find('.active').removeClass('active');
			$('.y-pageNav').find('.is-active').removeClass('is-active');
			$('.y-pageNav .dropdown:visible').slideUp();
			$('#pageOverlay').removeClass('active');
			$('html').removeClass('nav-open utility-open');
		}
	}());

	// login in header
	(function() {
		// validate
		var $formWrapper = $('.siteLogin');
		var $form = $formWrapper.find('form');

		var msgInvalidEmail = $formWrapper.find('.msgInvalidEmail').data('msg');

		$form.validate({
			errorClass: 'field-validation-error',
			rules: {
				email: {
					required: true,
					email: true
				},
				password: {
					required: true
				}
			},
			submitHandler: function(form) {
				form.submit();
			}
		});

		// message options: https://gist.github.com/lxneng/8192635
		jQuery.extend(jQuery.validator.messages, {
			email: msgInvalidEmail
		});

		// submit
		var $btn = $formWrapper.find('.btn');
		var $errorGeneric = $formWrapper.find('.genericError');
		var $errorPasswordOrUser = $formWrapper.find('.passwordOrUserError');

		$btn.click(function(e) {
			e.preventDefault();

			var txtEmail = $formWrapper.find('#Email').val();
			var txtPassword = $formWrapper.find('#Password').val();

			$errorGeneric.addClass('hidden');
			$errorPasswordOrUser.addClass('hidden');

			$btn.addClass('btnClicked');

			$.ajax({
				method: 'POST',
				url: '/api/sitecore/Account/NavLogin',
				data: '{"UserName": "' + txtEmail + '", "Password": "' + txtPassword + '"}',
				contentType: 'application/json; charset=utf-8',
				success: function(data, status, xhr) {
					window.location.reload();
				},
				error: function(response) {
					$btn.removeClass('btnClicked');
					switch (response.status) {
						case 500: {
							$errorPasswordOrUser.removeClass('hidden');
							break;
						}
						case 400: {
							$errorGeneric.removeClass('hidden');
							break;
						}
						case 401: {
							$errorPasswordOrUser.removeClass('hidden');
							break;
						}
						default: {
							$errorGeneric.removeClass('hidden');
						}
					}
				}
			});
		});
	}());

	// footer nav
	(function() {
		$('.footerNav .toggle').on('click', function(e) {
			e.preventDefault();
			$(this).parent('li').siblings('li').slideToggle(300);
			$(this).parent().parent('ul').toggleClass('active');
		});
	}());

	// carousel
	(function carousel() {

		// video modal
		function openHeroCarouselVideoModal($slide) {
			var autoplayBoolean = $slide.find('.video').attr('data-autoplay');
			var $modalHtml5;
			var $modalIframe;
			var modalIframeSrc;

			$.magnificPopup.open({
				closeMarkup: '<button class="mfp-close">close</button>',
				type: 'inline',
				items: {
					src: $slide.attr('data-popup-src'),
					type: 'inline'
				},
				callbacks: {
					open: function() {
						$modalIframe = $('.mfp-content').find('.video').find('iframe');
						$modalHtml5 = $('.mfp-content').find('.video').find('video');

						if ($modalIframe.length) {
							modalIframeSrc = $modalIframe.attr('src');
							$modalIframe.attr('src', modalIframeSrc + '&amp;autoplay=' + autoplayBoolean);
						} else if ($modalHtml5.length && autoplayBoolean === 'true') {
							$modalHtml5.get(0).play();
						}
					},
					beforeClose: function() {
						if ($modalIframe.length) {
							$modalIframe.attr('src', modalIframeSrc + '&amp;autoplay=0');
						}
					}
				}
			});
		}

		$('.jsHeroCarouselVideoModal').each(function() {
			$(this).on('click', function(e) {
				var $this = $(this);
				var $hasLink = $(this).find('a.carouselLink');
				var $noLink = $(this).find('div.carouselLink');
				// prevent modal from firing when clicking on a link that has a link
				if ($hasLink.length > 0 && e.target !== $hasLink && $.contains($hasLink[0], e.target) == false) {
					openHeroCarouselVideoModal($this);
				}
				// everything inside carousel slide can trigger the modal when no link has been set
				if ($noLink.length > 0) {
					openHeroCarouselVideoModal($this);
				}
			});
		});

		function initCarousels(isDesktop) {
			// initialize defaults
			$('.carousel:not(.carouselMaster)').each(function() {
				var popupItems = null;
				var slides = $(this).find('.carouselCell');
				var slideCount = $(this).find('.carouselCell').length;
				var slideWidth = $(this).find('.carouselCell').outerWidth();
				var contentWidth = slideCount * slideWidth;
				var carouselWidth = $(this).innerWidth();
				var options = {
					arrowShape: {
						  x0: 10,
						  x1: 60, y1: 50,
						  x2: 65, y2: 40,
						  x3: 25
						},
					autoPlay: false,
					cellAlign: 'left',
					cellSelector: '.carouselCell',
					imagesLoaded: true,
					wrapAround: true
				};

				if (contentWidth <= carouselWidth) {
					// disable wraparound when slides are smaller than container
					options.wrapAround = false;
					// disable draggable on desktop only
					if (isDesktop) {
						options.draggable = false;
					}
					// add class to hide ui controls on desktop
					$(this).addClass('noCarouselUiDesktop');
				}

				// initialise flickity
				var $carousel = $(this).flickity(options);

				// setting speed
				var speed = {};
				if ($carousel.data('speed') !== '') {
					speed = {
						autoPlay: $carousel.data('speed')
					};
				} else {
					speed = {
						autoPlay: 7000
					};
				}
				$(this).flickity(speed);

				// video
				function onLoadeddata(e) {
					var cell = $carousel.flickity('getParentCell', e.target);
					$carousel.flickity('cellSizeChange', cell && cell.element);
				}
				$carousel.find('.videoPlayer, .jsCarouselBgVideo').each(function(i, video) {
					$(video).on('loadeddata', onLoadeddata);
					if ($(this).attr('autoplay')) {
						video.play();
					}
				});

				// add class if only one slide
				var $flkty = $carousel.data('flickity');
				if ($flkty.cells.length < 2) {
					$flkty.unbindDrag();
					$carousel.addClass('single');
				}

				// start sliding
				// if ($carousel.data('play') && (!$carousel).find('.video')) {
				// 	$carousel.flickity('playPlayer');
				// }
				if ($carousel.data('play')) {
					$carousel.flickity('playPlayer');
				}

				// html5 bg video
				$carousel.find('.jsCarouselBgVideo').each(function() {
					var $video = $(this);
					var videoElement = this;
					var $controls = $video.parents('.carouselCell').find('.jsBgVideoControls');
					var $playBig = $video.parents('.carouselCell').find('.jsPlayBig');
					var $play = $controls.find('.jsPlay');
					var $mute = $controls.find('.jsMute');
					// var $fullscreen = $controls.find('.jsFullScreen');
					var $seekBar = $controls.find('.jsSeekBar');
					var $volumeBar = $controls.find('.jsVolumeBar');

					var isIE11 = /Trident.*rv[ :]*11\./.test(navigator.userAgent);

					var playVideo = function() {
						$video.css('opacity', 1);
						videoElement.play();
						$play.find('i').addClass('yamicon-pause').removeClass('yamicon-play').attr('aria-label', 'Pause');
						if ($playBig.is(':visible')) {
							$playBig.fadeOut();
						}
					};

					var pauseVideo = function() {
						videoElement.pause();
						$play.find('i').addClass('yamicon-play').removeClass('yamicon-pause').attr('aria-label', 'Play');
					};

					var muteVideo = function() {
						videoElement.muted = true;
						$mute.find('i').addClass('yamicon-muted').removeClass('yamicon-unmuted').attr('aria-label', 'Mute');
						$volumeBar.val(0);
						videoElement.volume = 0;
					};

					var unmuteVideo = function() {
						videoElement.muted = false;
						$mute.find('i').addClass('yamicon-unmuted').removeClass('yamicon-muted').attr('aria-label', 'Unmute');
						$volumeBar.val(1);
						videoElement.volume = 1;
					};

					var updateVideoProgress = function() {
						var time = videoElement.duration * ($seekBar.val() / 100);
						videoElement.currentTime = time;
					};

					var updateVideoVolume = function() {
						videoElement.volume = $volumeBar.val();
						if ($volumeBar.val() > 0) {
							videoElement.muted = false;
							$mute.find('i').removeClass('yamicon-muted').addClass('yamicon-unmuted').attr('aria-label', 'Unmute');
						} else {
							videoElement.muted = true;
							$mute.find('i').removeClass('yamicon-unmuted').addClass('yamicon-muted').attr('aria-label', 'Unmute');
						}
					};

					var resetVideo = function() {
						$seekBar.val(0);
						videoElement.currentTime = 0;
						$video.removeAttr('autoplay');
						$play.find('i').addClass('yamicon-play').removeClass('yamicon-pause').attr('aria-label', 'Play');
						$video.css('opacity', 0);
						$playBig.show();
					};

					// controls: big play button (non-autoplay vids only)
					$playBig.on('click', function() {
						if (videoElement.paused === true) {
							playVideo();
						}
					});

					// controls: play button in controls
					$play.on('click', function() {
						if (videoElement.paused === true) {
							playVideo();
						} else {
							pauseVideo();
						}
					});

					// controls: mute
					$mute.on('click', function() {
						if (videoElement.muted === false) {
							muteVideo();
						} else {
							unmuteVideo();
						}
					});

					// controls: fullscreen
					// $fullscreen.on('click', function() {
					// 	if (videoElement.requestFullscreen) {
					// 		videoElement.requestFullscreen();
					// 	} else if (videoElement.mozRequestFullScreen) {
					// 		videoElement.mozRequestFullScreen(); // firefox
					// 	} else if (videoElement.webkitRequestFullscreen) {
					// 		videoElement.webkitRequestFullscreen(); // webkit
					// 	} else if (videoElement.msRequestFullscreen) {
					// 		videoElement.msRequestFullscreen(); // ie11
					// 	}
					// });

					// controls: seek bar
					// ie doesn't fire 'input' on input ranges so we handle it separately
					if (!isIE11) {
						$seekBar.on('input', function() {
							updateVideoProgress();
						});
					} else {
						$seekBar.on('change', function() {
							updateVideoProgress();
						});
					}

					$video.on('timeupdate', function() {
						var value = (100 / videoElement.duration) * videoElement.currentTime;
						$seekBar.val(value);
					});

					// controls: volume bar
					// ie doesn't fire 'input' on input ranges so we handle it separately
					if (!isIE11) {
						$volumeBar.on('input', function() {
							updateVideoVolume();
						});
					} else {
						$volumeBar.on('change', function() {
							updateVideoVolume();
						});
					}

					// autoplay videos: update controls labels and mute by default
					if ($video.parents('.is-selected').length && $video.attr('autoplay')) {
						$play.find('i').toggleClass('yamicon-pause yamicon-play').attr('aria-label', 'Pause');
						muteVideo();
					}

					// autoplay videos: if it's not the first slide, stop autoplay
					if (!$video.parents('.is-selected').length && $video.attr('autoplay')) {
						pauseVideo();
					}

					// when video playing, don't autoplay the carousel
					if (!videoElement.paused === true) {
						$carousel.flickity('pausePlayer');
					}

					// when user goes to next slide, pause and mute video; remove video autoplay; resume regular carousel autoplay
					var selectedIndex = $flkty.selectedIndex;
					$carousel.on('select.flickity', function() {
						if (videoElement.paused === true && $video.parents('.is-selected').length) {
							resetVideo();
							playVideo();
							$carousel.flickity('pausePlayer');
						} else {
							// disregard same index and autoplay carousel selects
							var isSameIndex = selectedIndex == $flkty.selectedIndex;
							var isPlaying = $flkty.player.state == 'playing';
							if (isSameIndex || isPlaying) {
								return;
							}
							pauseVideo();
							muteVideo();
							$video.removeAttr('autoplay');
							$carousel.flickity('playPlayer');
						}
					});

					// when video ends
					$video.on('ended', function() {
						// if only one slide, play again
						if ($flkty.cells.length <= 1) {
							videoElement.play();
						}
						// else go to the next slide, resume autoplay, and reset video for next carousel loop
						else {
							$carousel.flickity('next');
							$carousel.flickity('playPlayer');
							resetVideo();
						}
					});
				});

			});

			// carousel master
			$('.carouselMaster').each(function() {
				var slideCount = $(this).find('.carouselCell').length;
				var slideWidth = $(this).find('.carouselCell').outerWidth();
				var contentWidth = slideCount * slideWidth;
				var carouselWidth = $(this).innerWidth();
				var optionsSlave = {
					arrowShape: {
						x0: 15,
						x1: 70, y1: 40,
						x2: 70, y2: 15,
						x3: 70
					},
					asNavFor: '.carouselSlave',
					autoPlay: false,
					groupCells: false,
					cellAlign: 'left',
					cellSelector: '.carouselCell',
					imagesLoaded: true,
					wrapAround: true
				};
				if (contentWidth <= carouselWidth) {
					// disable wraparound when slides are smaller than container
					optionsSlave.wrapAround = false;
					// prevent slides from aligning to the left
					optionsSlave.groupCells = '100%';
					// add class to hide ui controls on desktop
					$(this).addClass('noCarouselUiDesktop');
				}

				// initialise flickity
				var $carouselMaster = $(this).flickity(optionsSlave);

				// show master on click
				$carouselMaster.unbind('staticClick.flickity');
				$carouselMaster.on('staticClick.flickity', function(event, pointer, cellElement, cellIndex) {
					var master = $(this).closest('.carouselMaster').next('.carouselSlave');
					var allSlides = $(this).find('.carouselCell');
					// if not clicking a cell do nothing
					if (!cellElement) {
						return;
					}
					// clicking a cell thats already active just hides slave
					if ($(cellElement).hasClass('active')) {
						$(cellElement).removeClass('active');
						master.removeClass('open');
					} else if (allSlides.hasClass('active')) {
						allSlides.removeClass('active');
						$(cellElement).addClass('active');
					} else {
						$(cellElement).addClass('active');
						master.addClass('open');
					}
				});
			});
		}

		function initCarouselCategory(isDesktop) {
			$('.jsCarouselCategory').each(function() {
				var popupItems = null;
				var slides = $(this).find('.carouselCell');
				var slideCount = $(this).find('.carouselCell').length;
				var slideWidth = $(this).find('.carouselCell').outerWidth();
				var contentWidth = slideCount * slideWidth;
				var carouselWidth = $(this).innerWidth();
				var options = {
					arrowShape: {
						x0: 15,
						x1: 70, y1: 40,
						x2: 70, y2: 15,
						x3: 70
					},
					autoPlay: false,
					cellAlign: 'left',
					cellSelector: '.carouselCell',
					imagesLoaded: true,
					wrapAround: true
				};

				if (contentWidth <= carouselWidth) {
					// disable wraparound when slides are smaller than container
					options.wrapAround = false;
					// disable draggable on desktop only
					if (isDesktop) {
						options.draggable = false;
					}
					// add class to hide ui controls on desktop
					$(this).addClass('noCarouselUiDesktop');
				}

				// initialise flickity
				var $carousel = $(this).flickity(options);

				// setting speed
				var speed = {};
				if ($carousel.data('speed') !== '') {
					speed = {
						autoPlay: $carousel.data('speed')
					};
				} else {
					speed = {
						autoPlay: 7000
					};
				}
				$(this).flickity(speed);

				// add class if only one slide
				var $flkty = $carousel.data('flickity');
				if ($flkty.cells.length < 2) {
					$flkty.unbindDrag();
					$carousel.addClass('single');
				}

				if ($carousel.data('play')) {
					$carousel.flickity('playPlayer');
				}

			});
		}

		function destroyCarousels() {
			$('.carousel.flickity-enabled').each(function() {
				$(this).flickity('destroy');
			});
		}

		function destroyCategoryCarousels() {
			$('.jsCarouselCategory.flickity-enabled').each(function() {
				$(this).flickity('destroy');
			});
		}

		enquire.register('screen and (max-width: 1067px)', {
			match: function() {
				if ($('.carousel.flickity-enabled').length) {
					destroyCarousels();
				}
				if ($('.carousel')) {
					initCarousels();
				}
				if ($('.jsCarouselCategory')) {
					destroyCategoryCarousels();
				}
			}
		});

		enquire.register('screen and (min-width: 1068px)', {
			match: function() {
				if ($('.carousel.flickity-enabled').length) {
					destroyCarousels();
				}
				if ($('.carousel').length) {
					initCarousels(true);
				}
				if ($('.jsCarouselCategory')) {
					initCarouselCategory(true);
				}
			}
		});

		// resize for carousels / waypoints etc after everything is lazy loaded
		// set carouselContent cell heights
		(function() {
			if ($('.carousel').length) {
				$('.carousel:not(.carouselHero)').each(function() {
					var $module = $(this);
					var $cell = $module.find('.carouselCell');
					var update = function() {
						$module.flickity('resize');
						$cell.matchHeight();
						if ($module.find('.flickity-prev-next-button').length) {
							if ($module.find('.lazyloaded').length) {
								var $image = $module.find('.lazyloaded').first();
								var $imageHalf = ($image.outerHeight() / 2);
								$module.find('.flickity-prev-next-button').css('top', $imageHalf + 'px');
							}
						}
						Waypoint.refreshAll();
					};

					var breakpoint = 768;

					if (!$module.hasClass('noMob') || $module.hasClass('noMob') && window.outerWidth >= breakpoint) {
						this.addEventListener('load', update, true);

						$module.flickity();
					}

				});
			}
		}());

		// hide master
		$('.carouselSlave .btnClose').on('click', function(e) {
			e.preventDefault();
			$(this).closest('.carouselSlave').removeClass('open');
			$(this).closest('.carouselSlave').prev('.carouselMaster').find('.carouselCell.active').removeClass('active');
		});

	}());

	// resize for carousels / waypoints etc after everything is lazy loaded
	// set carouselContent cell heights
	(function() {
		if ($('.carousel').length) {
			$('.carousel:not(.carouselHero)').each(function() {
				var $module = $(this);
				var $cell = $module.find('.carouselCell');
				var update = function() {
					$module.flickity('resize');
					$cell.matchHeight();
					if ($module.find('.flickity-prev-next-button').length) {
						if ($module.find('.lazyloaded').length) {
							var $image = $module.find('.lazyloaded').first();
							var $imageHalf = ($image.outerHeight() / 2);
							$module.find('.flickity-prev-next-button').css('top', $imageHalf + 'px');
						}
					}
					Waypoint.refreshAll();
				};

				var breakpoint = 768;

				if (!$module.hasClass('noMob') || $module.hasClass('noMob') && window.outerWidth >= breakpoint) {
					this.addEventListener('load', update, true);

					$module.flickity();
				}
			});
		}
	}());


	// ---------------------------------------------------------------------
	// | components                                                        |
	// ---------------------------------------------------------------------

	// move sidebar
	(function() {
		enquire.register('screen and (max-width: 1067px)', {
			match: function() {
				if ($('.twoColumn').length) {
					if (!$('.searchForm').length){
						$('.twoColumn').each(function(index) {
							var $aside = $(this).children('aside');
							$(this).attr('data-col', index);
							$aside.appendTo('#pageMain').attr('data-col', index).wrap('<div class="container oneColumn colMove"></div>');
						});
					}
				}
			},
			unmatch: function() {
				if ($('.oneColumn.colMove').length) {
					if (!$('.searchForm').length){
						$('.oneColumn.colMove').each(function() {
							var $child = $(this).children('aside');
							var $childLoc = $child.attr('data-col');
							var $parent = $('#pageMain').find('.twoColumn[data-col="' + $childLoc + '"]');
							$child.appendTo($parent);
							$(this).remove();
						});
					}
				}
			}
		});
	}());

	// accordions
	(function() {
		// open the active accordion items on page load
		$('.jsAccordionItemParent.active').each(function() {
			$(this).find('.jsAccordionContent').css('display','block');
		});
		// accordion trigger
		$('.jsAccordion .jsAccordionTrigger').on('click', function(e) {
			e.preventDefault();
			var $triggerParent = $(this).parents('.jsAccordionItemParent');
			var $accordionContent = $triggerParent.find('.jsAccordionContent');
			$triggerParent.toggleClass('active');
			$accordionContent.stop(true).slideToggle(200);
		});
	}());

	// hide key feature tabs if only one
	// this is now handled in backend - left code here in case we need to re-enable later
	// (function() {
	// 	if ($('.keyFeatures').length) {
	// 		$('.keyFeatures').each(function() {
	// 			var $tabCount = $(this).find('.tabList li').length;
	// 			if ($tabCount == 1) {
	// 				$(this).find('.tabList').addClass('hidden');
	// 			}
	// 		});
	// 	}
	// }());

	// buttons
	(function() {
		// animate on submit
		var $btns = $('.btn[type="submit"]');

		$btns.each(function() {
			var $this = $(this);
			var $form = $this.parents('form');

			$form.on('submit', function() {
				$this.addClass('btnClicked');
				if ($form.closest('.form').hasClass('form--wffm')) {
					$('.form--wffm').append('<div class="formOverlay"><div class="formOverlayInner"><div class="lds-css ng-scope"><div style="width:100%;height:100%" class="lds-rolling"><div></div></div><span>Processing ...</span></div></div>');
				}
				var checkForErrors = function() {
					if ($form.find('.has-error').length || $('#termandcondition-error').is(':visible') || $('#products-error').is(':visible')){
						if(!$('#formRegistration').length){
							$this.removeClass('btnClicked');
						}
						$this.removeClass('btnClicked');

						if($form.closest('.form').hasClass('form--wffm')) {
							$('.formOverlay').remove();
						}
						clearInterval(timer);
						return;
					} else {
						if($('#formRegistration').length){
							$this.addClass('btnClicked');
						}
						clearInterval(timer);
					}
				};
				var timer = setInterval(checkForErrors, 200);
			});
		});

	}());


	$(document).ajaxSuccess(function() {
		// always remove the overlay on success
		if ($('.formOverlay').length) {
			$('.formOverlay').remove();
		}
	});

	// forms
	(function() {
		// check if postback
		function isPostBack() {
			// this frontend check is not foolproof, it's still consideredtrue if a page links to itself
			return document.referrer.indexOf(document.location.href) > -1;
		}
		// select dropdowns
		if ($('.form .select').length) {
			$('.form .select').each(function() {
				// set the placeholder to the first option in the select dropdown
				var $selectPlaceholder = $(this).find('option:eq(0)').html();
				// console.log($selectPlaceholder);
				$(this).select2({
					placeholder: $selectPlaceholder,
					width: '100%',
					templateResult: function (data, container) {
						if (data.element) {
							// add a css class to the faux select2 option if it existed on the original <option> tag
							$(container).addClass($(data.element).attr('class'));
						}
						return data.text;
					}
				});
			});
		}
		// datepicker placeholder
		if ($('.form .datePicker').length && !isPostBack) {
			// clear the default value on initial pageload, not on postback. so field values are kept on failed form submissions
			$('.form .datePicker').each(function() {
				// set the placeholder to the label
				var $datePickerPlaceholder = $(this).prev('.jsDatePickerLabel').html();
				$(this).attr({
					placeholder: $datePickerPlaceholder,
					value: null
				});
			});
		}
		// checkboxes & radios
		if ($('.form .checkbox').length || $('.form .radio').length) {
			// checkbox
			$('.form .checkbox').iCheck({
				checkboxClass: 'icheckbox_square'
			});
			// radio
			$('.form .radio').iCheck({
				radioClass: 'iradio_square'
			});
			// label styling
			$('.form .checkbox input, .form .radio input').on('ifToggled', function(event) {
				$(this).closest('label').toggleClass('checked');
			});
			// help block styling
			$('.form .checkbox input, .form .radio input').on('ifToggled', function(event) {
				$(this).parents('.checkbox, .radio').siblings('.help-block').toggleClass('checked');
			});
		}
		// date picker
		$('form .datePicker').each(function() {
			$(this).pickadate({
				format: 'dd-mmm-yyyy',
				clear: false,
				firstDay: 1,
				min: [1900,1,1],
				max: 5475, // 15 years * 365 days
				today: 'Today',
				selectYears: 100,
				selectMonths: true,
				onStart: function() {
					// required to ensure the dateformat is in the correct format pickdate wants
					// not required if the sitecore date format is the same as the format specified above
					// this.set('select', 'today');

					// clear the default value on initial pageload, not on postback. so you can read the placeholder text
					if (!isPostBack()) {
						// this one is for ie, there is another value clearing function above for other browsers
						this.clear();
					}
				},
				// fix for focus stealing
				onClose: function() {
					var activeElement = $(':focus');
					activeElement.blur();
				}
			});
		});

		// custom fed tweaks for server side validation
		if ($('.form').length) {
			$('.form').find('.field-validation-error').not(':empty').closest('.form-group').addClass('has-error');
		}

		// select 2
		//$('select').select2({
		//	templateResult: function(data, container) {
		//		if (data.element) {
		//			$(container).addClass($(data.element).attr('class'));
		//		}
		//		return data.text;
		//	}
		//});
	}());

	// filters
	(function() {
		$('.filterCollapsed .select').on('change', function() {
			var url = $('option:selected', this).data('url');
			window.location.href = url;
		});
		if ($('.filterExpanded').length) {
			var $h = $('.filterExpanded').height();
			var $more = $('.filterExpanded').find('.more > a');
			if ($h > 42) {
				$('.filterExpanded').addClass('row');
			}
			$more.on('click', function(e) {
				e.preventDefault();
				$(this).parent().parent('.filterExpanded').toggleClass('toggle');
			});
		}
	}());


	// read more
	(function() {
		$('.jsReadMoreTrigger').on('click', function(e) {
			e.preventDefault();
			$(this).closest('div').find('.jsReadMoreText').slideToggle('slow');
			$(this).hide();
		});
	}());

	// modal
	(function() {
		// separate galleries into separate magnific popups
		$('.jsImageGallery').each(function() {
			$(this).magnificPopup({
				delegate: '.jsImageGalleryLink',
				closeMarkup: '<button class="mfp-close">close</button>',
				preload: [0,1],
				image: {
					verticalFit: true
				},
				zoom: {
					enabled: true
				},
				gallery: {
					enabled: true
				}
			});
		});
		// generic modals
		$('.mfp-iframe, .mfp-inline, .mfp-ajax').magnificPopup({
			closeMarkup: '<button class="mfp-close">close</button>'
		});
		// video modals
		$('.mfp-video').each(function() {
			$(this).magnificPopup({
				closeMarkup: '<button class="mfp-close">close</button>',
				type: 'inline'
			});
		});
	}());

	// pagination
	(function() {
		if ($('.pagination').length) {
			$('.pagination').each(function() {
				// mobile only
				var $this = $(this);

				$('#ddlViewPerPage').on('change', function(event) {
					var url = $('#ddlViewPerPage').find('option:selected').attr('data-url');
					window.location.replace(url);
				});
				$('#ddlViewPerPageDesktop').on('change', function(event) {
					var url = $('#ddlViewPerPageDesktop').find('option:selected').attr('data-url');
					window.location.replace(url);
				});

				$('#ddlSortBy').on('change', function(event) {
					var url = $('#ddlSortBy').find('option:selected').attr('data-url');
					window.location.replace(url);
				});

				enquire.register('screen and (max-width: 767px)', {
					match: function() {
						$this.find('.active').next().addClass('visible');
						if ($this.children().eq(0).hasClass('active')) {
							$this.find('.active').next().next().addClass('visible');
						}
						$this.find('.active').prev().addClass('visible');
						if ($this.children().eq($this.children().length - 3).hasClass('active')) {
							$this.find('.active').prev().prev().addClass('visible');
						}
						// remove more & next
						if ($('.more', $this).prev().hasClass('active')) {
							$this.find('.more').hide();
							$this.find('.next').hide();
						} else if ($('.more', $this).prev().prev().hasClass('active')) {
							$this.find('.more').hide();
						}
						// remove prev
						if ($('.prev', $this).next().hasClass('active')) {
							$this.find('.prev').hide();
						}
						// remove more
						if ($this.find('> li.visible:not(.more)').length <= 3) {
							$this.find('.more').hide();
						}
					}
				});
				// tablet up
				enquire.register('screen and (min-width: 768px)', {
					match: function() {
						$this.find('.active').next().addClass('visible').next().addClass('visible');
						if ($this.children().eq(0).hasClass('active')) {
							$this.find('.active').next().next().next().addClass('visible').next().addClass('visible');
						} else if ($this.children().eq(2).hasClass('active')) { // prev, none, active...
							$this.find('.active').next().next().next().addClass('visible');
						}
						$this.find('.active').prev().addClass('visible').prev().addClass('visible');
						if ($this.children().eq($this.children().length - 3).hasClass('active')) { // length including prev and next
							$this.find('.active').prev().prev().prev().addClass('visible').prev().addClass('visible');
						} else if ($this.children().eq($this.children().length - 5).hasClass('active')) { // length including prev, ... and next
							$this.find('.active').prev().prev().prev().addClass('visible');
						}
						// remove more & next
						if ($('.more', $this).prev().hasClass('active')) {
							$this.find('.more').hide();
							$this.find('.next').hide();
						} else if ($('.more', $this).prev().prev().hasClass('active') || $('.more', $this).prev().prev().prev().hasClass('active')) {
							$this.find('.more').hide();
						}
						// remove prev
						if ($('.prev', $this).next().hasClass('active')) {
							$this.find('.prev').hide();
							$this.find('.active').next().addClass('visible').next().addClass('visible');
						}
						// remove more
						if ($this.find('> li.visible:not(.more)').length <= 5) {
							$this.find('.more').hide();
						}
					}
				});
			});
		}
	}());

	// social
	(function() {
		if ($('.jsShareEmail').length) {
			$('.jsShareEmail').on('click', function(e) {
				e.preventDefault();
				window.location.assign('mailto:?subject=' + encodeURIComponent(document.title) + '&body=' + encodeURIComponent(document.URL));
			});
		}
		if ($('.jsShareFacebook').length) {
			$('.jsShareFacebook').on('click', function(e) {
				e.preventDefault();
				window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(document.URL) + '&t=' + encodeURIComponent(document.URL));
			});
		}
		if ($('.jsShareGooglePlus').length) {
			$('.jsShareGooglePlus').on('click', function(e) {
				e.preventDefault();
				window.open('https://plus.google.com/share?url=' + encodeURIComponent(document.URL));
			});
		}
		if ($('.jsShareTwitter').length) {
			$('.jsShareTwitter').on('click', function(e) {
				e.preventDefault();
				window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent(document.title) + ' ' + encodeURIComponent(document.URL));
			});
		}
	}());

	// quicklinks
    // client no longer wishes to see quicklinks on mobile - https://switchit.atlassian.net/plugins/servlet/ac/com.thed.zephyr.je/general-search-test-executions?project.id=14202&issue.id=26409&execution.id=0001477267978448-242ac112-0001#!
    // (function() {
    //     if ($('#quicklinksContainer').length && $('#pageTitle').length) {
    //         var defaultLoc = $('#quicklinksContainer .container');
    //         var pageTitleLoc = $('#pageTitle');
    //         var quickLinks = $('#quicklinksContainer .quicklinks');
    //         // move quick links after page title on mobile
    //         enquire.register('screen and (max-width: 767px)', {
    //             match: function() {
    //                 quickLinks.insertAfter(pageTitleLoc);
    //             },
    //             unmatch: function() {
    //                 defaultLoc.prepend(quickLinks);
    //             }
    //         });
    //     }
    // }());

    // quicklinks sticky waypoints
    (function() {
        var quicklinks = $('#quicklinksContainer');
        if (quicklinks.length > 0) {
            var stickyQuicklinks = new Waypoint.Sticky({
                element: quicklinks[0]
            });
        }
	}());

	(function() {
		var accordionToTab = function() {
			$('.jsAccordionToTab').each(function() {
				var $this = $(this);
				var $tabParent = $this.find('.accordion-to-tab__tabs-list-item');
				var $tabLinks = $this.find('.jsAccordionToTabTab');
				var $tabContent = $this.find('.jsAccordionToTabContent');
				var $accordionLinks = $this.find('.jsAccordionToTabTrigger');
				var $items = $this.find('.jsAccordionToTabItem');
				$tabLinks.on('click', function() {
					var index = $(this).attr('rel');
					$items.removeClass('accordion-to-tab__item--active');
					$items.filter('[rel^="' + index + '"]').addClass('accordion-to-tab__item--active');
					$accordionLinks.attr('aria-expanded', false);
					$accordionLinks.filter('[id="tabTrigger' + index + '"]').attr('aria-expanded', true);
					$tabContent.attr('aria-hidden', true);
					$tabContent.filter('[id="tabContent' + index + '"]').attr('aria-hidden', false);
					$tabParent.removeClass('accordion-to-tab__tabs-list-item--active');
					$tabLinks.filter('[rel^="' + index + '"]').parent('.accordion-to-tab__tabs-list-item').addClass('accordion-to-tab__tabs-list-item--active');
				});
				$accordionLinks.click(function() {
					var index = $(this).attr('rel');
					$items.removeClass('accordion-to-tab__item--active');
					$items.filter('[rel^="' + index + '"]').addClass('accordion-to-tab__item--active');
					$accordionLinks.attr('aria-expanded', false);
					$accordionLinks.filter('[id="tabTrigger' + index + '"]').attr('aria-expanded', true);
					$tabContent.attr('aria-hidden', true);
					$tabContent.filter('[id="tabContent' + index + '"]').attr('aria-hidden', false);
					$tabParent.removeClass('accordion-to-tab__tabs-list-item--active');
					$tabLinks.filter('[rel^="' + index + '"]').parent('.accordion-to-tab__tabs-list-item').addClass('accordion-to-tab__tabs-list-item--active');
				});
			});
		};
		if ($('.jsAccordionToTab').length) {
			accordionToTab();
		}
	})();

	// tabs
	(function() {
		if ($('.jsTabs').length) {
			$('.jsTabs').each(function() {
				var tab = $(this).find('.tabList .tab');
				var content = $(this).find('.tabContent > div');
				$(tab).on('click', function(e) {
					// tab
					var id = $(this).attr('href');
					e.preventDefault();
					$(this).parent().siblings().removeClass('active');
					$(this).parent().addClass('active');
					$(content).not(id).removeClass('active').css('display', 'none');
					$(id).addClass('active').fadeIn();
					// refresh carousels inside the tab
					var childCarousel = $(id).find('.carousel');
					var slideCount = childCarousel.find('.carouselCell').length;
					var slideWidth = childCarousel.find('.carouselCell').outerWidth();
					var contentWidth = slideCount * slideWidth;
					var carouselWidth = childCarousel.innerWidth();
					var carouselSetting = {};
					if (childCarousel.length) {
						childCarousel.flickity('resize');
						if (contentWidth <= carouselWidth) {
							carouselSetting.wrapAround = false;
							// 	carouselSetting.draggable = false;
							childCarousel.addClass('noCarouselUiDesktop');
							childCarousel.flickity(carouselSetting);
						}
						else {
						    //remove noCarouselUiDesktop otherwise no navigation
						    carouselSetting.wrapAround = true;						    
						    childCarousel.removeClass('noCarouselUiDesktop');
						    childCarousel.flickity(carouselSetting);
						}
					}
				});
			});
		}
	}());

	// resize
	(function() {
		// fire resize event when clicking on 'map view' tab on find a dealer
		$('.jsWindowResize').on('click', function(e) {
			e.preventDefault();
			window.dispatchEvent(new Event('resize'));
		});
	}());

	// tables - wrap wysiwyg tables in table-responsive class
	(function() {
		if ($('.ww > table').length) {
			$('.ww > table').each(function() {
				$(this).wrap('<div class="tableResponsive"></div>');
			});
		}
	}());

	// tooltips
	(function tooltipBasic() {
		if ($('.tooltip').length) {
			$('.tooltip').each(function() {
				$(this).tooltipster({
					content: $(this).data('tooltip'),
					maxWidth: 320,
					trigger: 'custom',
					triggerOpen: {
						click: true,
						touchstart: true
					},
					triggerClose: {
						click: true,
						scroll: true,
						tap: true
					}
				});
			});
		}
	}());

	// tooltip hover
	(function tooltipHover() {
		if ($('.tooltipHover').length) {
			$('.tooltipHover').each(function() {
				$(this).tooltipster({
					content: $(this).data('tooltip'),
					maxWidth: 320
				});
			});
		}
	}());

	// waypoints
	(function() {
		var $pageAnchorsContainer = $('#pageAnchors');
		var $pageAnchors = $('#pageAnchors a');
		function removeAllPageAnchors() {
			$pageAnchors.removeClass('active');
		}
		function removeActivePageAnchor(id) {
			$pageAnchorsContainer.find('a[href="#' + id + '"]').removeClass('active');
		}
		function addActivePageAnchor(id) {
			$pageAnchorsContainer.find('a[href="#' + id + '"]').addClass('active');
		}
		// only generate waypoints when more than one
		if ($('.waypoint').length > 1) {
			// generate page anchors
			$('.waypoint[name]').each(function() {
				var $name = $(this).attr('name').replace(/[\W_]/g, ''); // strip spaces and special characters
				var $title = $(this).attr('data-title');
				var $pageAnchorsContainer = $('#pageAnchors');
				$(this).attr('name', $name);
				$pageAnchorsContainer.append('<li><a class="anchor scrollTo" href="#' + $name + '" data-title="' + $title + '"><span>' + $title + '</span></a></li>');
			});
			// waypoint register
			$('.waypoint').each(function() {
				var $point = $(this).attr('name');
				var $inview = new Waypoint.Inview({
					element: $(this)[0],
					enter: function(direction) {
						removeAllPageAnchors();
						addActivePageAnchor($point);
					},
					entered: function(direction) {
						removeAllPageAnchors();
						addActivePageAnchor($point);
					},
					exited: function(direction) {
						removeActivePageAnchor($point);
					}
				});
			});
			// waypoints show / hide
			var $didScroll;
			var $lastScrollTop = 0;
			var $delta = 5;
			var $crumbs = $('.breadcrumbsContainer').outerHeight();
			var $carousel = $('.carouselHero.flickity-enabled').outerHeight();
			var $links = $('.quicklinksContainer').outerHeight();
			var $top = $crumbs + $carousel + $links;
			$(window).scroll(function(event) {
				$didScroll = true;
			});
			setInterval(function() {
				if ($didScroll) {
					hasScrolled();
					$didScroll = false;
				}
			}, 100);
			hasScrolled = function() {
				var $st = $(this).scrollTop();
				if (Math.abs($lastScrollTop - $st) <= $delta) {
					return;
				}
				if ($st > $top) {
					$('#pageAnchors').addClass('active');
				} else {
					$('#pageAnchors').removeClass('active');
				}
			};
		}
	}());

	// scroll to
	(function() {
		// this bind event has to come last so it catches generated markup above
		$('.scrollTo').on('click', function(e) {
			var hash = $(this).attr('href');
			var target = $($(this).attr('href'));
			// var padding = ($(window).height() / 2) - 200;
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			if (target.length) {
				e.preventDefault();
				$('html, body').animate({
					scrollTop: target.offset().top
				}, 400);
				window.location.hash = hash;
			}
			$(this).addClass('active');
		});
	}());

	// ---------------------------------------------------------------------
	// | page specific                                                     |
	// ---------------------------------------------------------------------

	// ---------------------------------------------------------------------
	// | search                                                    |
	// ---------------------------------------------------------------------

	(function() {
		// populate current filter text on page load and on click
		function getCurrentSearchFilterType() {
			var activeFilterType = $('#searchResultsFilters li.active a').html();
			$('#currentSearchFilterType').text(activeFilterType);
		}
		$('.filterTabs .tabList a').on('click', function() {
			getCurrentSearchFilterType();
		});
		getCurrentSearchFilterType();
	}());

	// ----------------------------------
	// find a dealer page               |
	// ----------------------------------
	(function() {
		// toggle filters on mobile
		$('#btnToggleFilters').on('click', function() {
			$('#findDealerFilters').slideToggle();
			$('#findDealerFiltersMobile').toggleClass('open');
			return false;
		});
		// populate current filter text on page load and on click
		function getCurrentFilterType() {
			var activeFilterType = $('#findDealerFilters li.active a').html();
			$('#currentFilterType').text(activeFilterType);
		}
		$('.filterTabs .tabList a').on('click', function() {
			getCurrentFilterType();
		});
		getCurrentFilterType();
		// scroll dealers
		$('.findDealerResultsNav button').on('click', function(e) {
			var dealerHeight = $('.findDealerResultsList li:first-of-type').outerHeight();
			e.preventDefault();
			// up
			if (e.target === $('.btnUp')[0] || e.target === $('.yamicon-angle-up')[0]) {
				$('.findDealerResultsList').animate({
					scrollTop: '-=' + dealerHeight
				}, 200);
			}
			// down
			if (e.target === $('.btnDown')[0] || e.target === $('.yamicon-angle-down')[0]) {
				$('.findDealerResultsList').animate({
					scrollTop: '+=' + dealerHeight
				}, 200);
			}
		});
	}());

	// ----------------------------------
	// global search page               |
	// ----------------------------------
	(function() {
		var searchTermStr = getUrlVars(window.location.href).term;
		if (searchTermStr !== undefined && searchTermStr !== '') {
			var searchTerm = decodeEntities(searchTermStr);
			$('#txtSiteSearch').val(searchTerm);
			if (searchTerm.length >= 3) {
			    $('.jsSiteSearchbutton').removeAttr('disabled');
			}
		} else {
			$('#txtSiteSearch').val('');
		}

		function getUrlVars(url) {
			var vars = [];
			var hash = [];
			var hashes = url.slice(url.indexOf('?') + 1).split('&');
			for (var i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		}

		function decodeEntities(encodedString) {
			return unescape(encodedString).replace(/\+/g, ' ');
		}
	}());

	var timeout = null;

    $('.jsSiteSearchTerm').keyup(function(){			
		
        var $this = $(this);
        var containerId = $this.attr('data-containerId');
        var isYshop = $this.attr('data-isYshop');
        var apiURL = '/api/corpsearch/GetCorpPredicate';

        if (isYshop == 'true')
        {
            apiURL = '/api/yshopsearch/Getyshoppredicate';
        }

        if ($this.val().length >= 3) {
            $('.jsSiteSearchbutton').removeAttr('disabled');
        }
        else
        {
            $('.jsSiteSearchbutton').attr('disabled', 'disabled');
        }

        clearTimeout(timeout);

        //trigger after use stop typing for 1 sec
        timeout = setTimeout(function () {                       

            if ($this.val() && $this.val().length >= 3) {               

                var entries = [];
                var inputStr = String($this.val());

                $.ajax({
                    method: 'GET',
                    url: apiURL,
                    data: { searchTerm: inputStr },
                    success: function (data, status, xhr) {

                        var a, b;
                        $('.autocomplete-items').remove();

                        a = document.createElement("DIV");
                        a.setAttribute("id", containerId + "autocomplete-list");
                        a.setAttribute("class", "autocomplete-items");
                        /*append the DIV element as a child of the autocomplete container:*/
                        $(containerId).append(a);
                        
                        data.forEach(function (el)
                        {
                            b = document.createElement("DIV");
                            /*make the matching letters bold:*/
                            b.innerHTML = "<strong>" + el + "</strong>";                            
                            /*insert a input field that will hold the current array item's value:*/
                            b.innerHTML += "<input type='hidden' value='" + el + "'>";
                            /*execute a function when someone clicks on the item value (DIV element):*/
                            b.addEventListener("click", function(e) {
                                /*insert the value for the autocomplete text field:*/
                                $this.val(this.getElementsByTagName("input")[0].value);
                                /*close the list of autocompleted values,
                                (or any other open lists of autocompleted values:*/
                                $('.autocomplete-items').remove();
                            });
                            a.appendChild(b);
                        });

                    },
                    error: function (response) {
                        console.log("sitesearch error :" + response);
                    }
                });
            }            
                
        }, 500);
        
    });
    
    /*execute a function when someone clicks in the document:*/
    document.addEventListener("click", function (e) {
        $('.autocomplete-items').hide();
    });

	// ----------------------------------
	// account registration             |
	// ----------------------------------
	(function() {
		// next step buttons mobile
		$('.jsNextStepBtn').on('click', function(e) {
			e.preventDefault();
			var $currentParent = $(this).parents('.jsAccordionItemParent');
			var $nextParent;
			if ($currentParent.next('.jsAccordionItemParent').length > 0) {
				$nextParent = $currentParent.next('.jsAccordionItemParent');
			} else {
				$nextParent = $currentParent.parent().next();
			}
			var $nextContent = $nextParent.find('.jsAccordionContent');
			var $nextTrigger = $nextParent.find('.jsAccordionTrigger');
			$currentParent.removeClass('active');
			$nextParent.addClass('active');
			$nextContent.slideToggle(200);
			$('html, body').stop(true).animate({
				scrollTop: $nextTrigger.offset().top
			}, 200);
		});
		// remove accordion states when moving from mobile to desktop
		enquire.register('screen and (min-width: 1068px)', {
			match: function() {
				var $accordionParent = $('.jsRegistrationAccordion').find('.jsAccordionItemParent');
				var $accordionContent = $accordionParent.find('.jsAccordionContent');
				$accordionParent.each(function() {
					$(this).removeClass('active');
				});
				$accordionContent.each(function() {
					$(this).removeAttr('style');
				});
			}
		});
	})();

	// ----------------------------------
	// product detail page              |
	// ----------------------------------
	// handle hiding of empty sections
	// (function() {
	// 	// price and offers
	// 	$('.priceAndOffers').each(function() {
	// 		var $this = $(this);
	// 		var $priceModule = $(this).find('.priceContainer').length;
	// 		var $offersModule = $(this).find('.offersContainer').length;
	// 		if ($priceModule === 0) {
	// 			$this.addClass('noPrice');
	// 		}
	// 		if ($offersModule === 0) {
	// 			$this.addClass('noOffers');
	// 		}
	// 		if ($priceModule === 0 && $offersModule === 0) {
	// 			$this.addClass('hidden');
	// 		}
	// 	});
	// 	// links and brochures
	// 	$('.linksAndBrochures').each(function() {
	// 		var $this = $(this);
	// 		var $linksModule = $(this).find('.linksContainer').length;
	// 		var $brochuresModule = $(this).find('.brochuresContainer').length;
	// 		if ($linksModule === 0) {
	// 			$this.addClass('noLinks');
	// 		}
	// 		if ($brochuresModule === 0) {
	// 			$this.addClass('noBrochures');
	// 		}
	// 		if ($linksModule === 0 && $brochuresModule === 0) {
	// 			$this.addClass('hidden');
	// 		}
	// 	});
	// 	// technical specification & colour images
	// 	$('.techSpecs').each(function() {
	// 		var $this = $(this);
	// 		var $specsModule = $(this).find('.specs').length;
	// 		var $coloursModule = $(this).find('.colours .jsImageGallery').length;
	// 		if ($specsModule === 0) {
	// 			$this.addClass('noSpecs');
	// 		}
	// 		if ($coloursModule === 0) {
	// 			$this.addClass('noColours');
	// 		}
	// 		if ($specsModule === 0 && $coloursModule === 0) {
	// 			$this.parent('.section').addClass('hidden');
	// 		}
	// 	});
	// }());
	(function() {
		// price and offers
		$('.priceAndOffers').each(function() {
			var $this = $(this);
			var $priceModule = $(this).find('.priceContainer').length;
			var $offersModule = $(this).find('.offersContainer').length;
			if ($priceModule === 0) {
				$this.addClass('noPrice');
			}
			if ($offersModule === 0) {
				$this.addClass('noOffers');
			}
			if ($priceModule === 0 && $offersModule === 0) {
				$this.addClass('hidden');
			}
		});
		// links and brochures
		$('.linksAndBrochures').each(function() {
			var $this = $(this);
			var $linksModule = $(this).find('.linksContainer').length;
			var $brochuresModule = $(this).find('.brochuresContainer').length;
			if ($linksModule === 0) {
				$this.addClass('noLinks');
			}
			if ($brochuresModule === 0) {
				$this.addClass('noBrochures');
			}
			if ($linksModule === 0 && $brochuresModule === 0) {
				$this.addClass('hidden');
			}
		});
		// technical specification & colour images
		$('.techSpecs').each(function() {
			var $this = $(this);
			var $specsModule = $(this).find('.specs').length;
			var $coloursModule = $(this).find('.colours .jsImageGallery').length;
			if ($specsModule === 0) {
				$this.addClass('noSpecs');
			}
			if ($coloursModule === 0) {
				$this.addClass('noColours');
			}
			if ($specsModule === 0 && $coloursModule === 0) {
				$this.parent('.section').addClass('hidden');
			}
		});
	}());

	// register toggle text function
	$.fn.extend({
		toggleText: function(a, b) {
			return this.text(this.text() == b ? a : b);
		}
	});

	// product rotator 360 spin
	(function() {

		var $productRotator = $('#jsProductRotator');
		var numOfFrames = 36;
		var lastFrameNum = 36;

		if ($productRotator.length) {

			$productRotator.reel({
				indicator: 0,
				frames: numOfFrames,
				frame: lastFrameNum,
				speed: 0,
				preloader: 20,
				images: '2017-Yamaha-YZF-R1M-EU-Silver-Blu-Carbon-VR360-#.jpg',
				path: '/assets/images/_temp/product-rotator/',
				cursor: 'hand',
				responsive: true
			});

			var spinnedOnce = false;
			var inview = new Waypoint.Inview({
				element: $productRotator[0],
				entered: function(direction) {
					if (spinnedOnce === false) {
						// console.log('1 - ' + spinnedOnce);
						$productRotator.trigger('play', 0.7).bind('frameChange', function(e, set_frame, frame) {
							if (frame == lastFrameNum) {
								// console.log('before ' + $(this));
								$productRotator.trigger('stop');
								// console.log('after ' + $(this));
							}
							// console.log('spin');
						});
						spinnedOnce = true;
						// console.log('2 - ' + spinnedOnce);
						// inview.disable();
						// inview.destroy();
					}
				}
			});

			// $('#goFullscreen').on('click', function(e) {
			// 	inview.disable();
			// 	inview.destroy();
			// 	$("#productRotator-reel").fullScreen(true);
			// });

			// $(document).bind("fullscreenchange", function() {
			// 	inview.disable();
			// 	inview.destroy();
			// 	console.log("Fullscreen " + ($(document).fullScreen() ? "on" : "off"));
			// });

		}

	}());
});
